import { useEffect, useRef, useState } from "react";

function LazyImage({ src, alt, placeholder = "/assets/img/no_image.png", className = "", onClick }) {
    const imgRef = useRef(null);
    const [imageSrc, setImageSrc] = useState(placeholder);

    useEffect(() => {
        const imgElement = imgRef.current;
        if (!imgElement) return;

        // Initially show placeholder
        setImageSrc(placeholder);

        const loadImage = () => {
            if (!src) return; // Prevent loading if src is empty

            const tempImg = new Image();
            tempImg.src = `${src}?cache=${Date.now()}`; // Cache-busting for fresh load

            tempImg.onload = () => setImageSrc(src); // Load actual image
            tempImg.onerror = () => setImageSrc(placeholder); // Fallback on error
        };

        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadImage();
                        observer.unobserve(imgElement); // Ensure it only loads once
                    }
                });
            }, { threshold: 0.1 }); // Trigger when 10% of the image is visible

            observer.observe(imgElement);
            return () => observer.disconnect(); // Cleanup observer on unmount
        } else {
            // Fallback for older browsers
            loadImage();
        }
    }, [src, placeholder]);

    return <img ref={imgRef} src={imageSrc} alt={alt} className={className} loading="lazy" onClick={onClick} />;
}

export default LazyImage;
